import { actionTypes } from "./actions";

const initialState = {
  data: [],
  decentralizedEdit: {
    POSCity: "",
    POSDistrict: "",
    POSLegalName: "",
    stateDescription: "",
    POSStatus: "",
    POSStreet: "",
    POSStreetNumber: "",
    taxcategoryDescription: "",
    POS_TaxCategorySK: "",
    POS_StateSK: "",
    POSTaxID: "",
    POSXCoordinate: "",
    POSYCoordinate: "",
    POSZipCode: "",
  },
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.SET_POS_DECENTRALIZED:
      return {
        ...state,
        data: payload,
      };

    case actionTypes.SET_DECENTRALIZED_FILTERED_RESULTS:
      return {
        ...state,
        data: payload,
      };

    case actionTypes.SET_POS_DECENTRALIZED_BY_ID:
      return {
        ...state,
        decentralizedEdit: payload,
      };

    case actionTypes.EDIT_CHILD_POS_FORM_CHANGE:
      return {
        ...state,

        decentralizedEdit: {
          ...state.decentralizedEdit,
          [payload.name]: payload.value,
        },
      };

    default:
      return {
        ...state,
      };
  }
};
